import { Route, Switch } from 'react-router-dom';
import { ROUTES } from '../../constants/routes';
import { Bonuses } from './pages/Bonuses';
import { AddEvent } from './pages/AddEvent';
import { DetailEvent } from './pages/DetailEvent';
import { EventsHistory } from './pages/EventsHistory';
import { CreatePackage } from './pages/CreatePackage';
import { EditPackage } from './pages/EditPackage';

export const BonusesRoutes = () => {
  return (
    <Switch>
      <Route path={ROUTES.BONUSES} exact={true} component={Bonuses} />
      <Route path={ROUTES.BONUSES_ADD_EVENT} component={AddEvent} />
      <Route path={ROUTES.BONUSES_DETAIL_EVENT} component={DetailEvent} />
      <Route path={ROUTES.BONUSES_COPY_EVENT} component={AddEvent} />
      <Route path={ROUTES.BONUSES_EVENTS_HISTORY} component={EventsHistory} />
      <Route path={ROUTES.BONUSES_CREATE_PACKAGE} component={CreatePackage} />
      <Route path={ROUTES.BONUSES_EDIT_PACKAGE} component={EditPackage} />
    </Switch>
  );
};
